import { useEffect } from 'react';

import { isBrowser } from '../helpers/is-browser';
import { getLocalStorageItem, setLocalStorageItem } from '../helpers/utils';
import useGetMobileAppWebViewHeader from './use-get-mobile-app-web-view';

const useNewsletterPopupAutomation = () => {
  const isWebView = useGetMobileAppWebViewHeader();

  useEffect(() => {
    if (!isBrowser || isWebView) return;

    // Utility to check conditions before showing popup
    const checkPopupConditions = () => {
      const hasTriggered = getLocalStorageItem('newsletterPopUpTriggered');
      const hasSubscribedToNewsletter = getLocalStorageItem(
        'hasSubscribedToNewsletter',
      );
      const hasClosedWithoutSubscribing = getLocalStorageItem(
        'hasClosedWithoutSubscribing',
      );
      const hasUnsubscribedToNewsletter = getLocalStorageItem(
        'hasUnSubscribedToNewsletter',
      );
      const lastPopupClosedDate = getLocalStorageItem('lastPopupClosedDate');

      // If the user has subscribed or unsubscribed, don't show the pop-up
      if (
        hasSubscribedToNewsletter === 'true' ||
        hasUnsubscribedToNewsletter === 'true'
      )
        return false;

      // If the user has closed the pop-up without subscribing, check if 30 days have passed since closure
      if (
        hasTriggered === 'true' &&
        hasClosedWithoutSubscribing === 'true' &&
        lastPopupClosedDate
      ) {
        const currentDate = new Date();
        const closedDateObj = new Date(lastPopupClosedDate);
        const diffInMillis = currentDate.getTime() - closedDateObj.getTime();

        // If more than 90 days have passed, return true to show the pop-up
        if (diffInMillis > 7776000000) {
          setLocalStorageItem('newsletterPopUpTriggered', 'true');
          return true;
        }
        return false;
      }

      // Show the pop-up after 10 seconds if none of the conditions are met
      if (!hasSubscribedToNewsletter && !hasClosedWithoutSubscribing) {
        if (hasTriggered === 'true') return false;
        setLocalStorageItem('newsletterPopUpTriggered', 'true');
        return true;
      }

      return false;
    };

    // Check the conditions and trigger the pop-up if appropriate
    if (checkPopupConditions()) {
      setTimeout(() => {
        const hasUnsubscribedToNewsletter = getLocalStorageItem(
          'hasUnSubscribedToNewsletter',
        );
        const hasSubscribedToNewsletter = getLocalStorageItem(
          'hasSubscribedToNewsletter',
        );

        if (
          hasSubscribedToNewsletter !== 'true' &&
          hasUnsubscribedToNewsletter !== 'true'
        ) {
          const newsletterButton = document.getElementById('newsletter-button');
          newsletterButton?.click();
        }
      }, 30000);
    }
  }, []);
};

export default useNewsletterPopupAutomation;
